import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3233964802 from "../../../../../packages/component/src/components/tag/demo/demo1.js?loadDemo";
import legacyImportDemo_3320145185 from "../../../../../packages/component/src/components/tag/demo/demo2.js?loadDemo";
import legacyImportDemo_3997807168 from "../../../../../packages/component/src/components/tag/demo/demo3.js?loadDemo";
import legacyImportDemo_4074051308 from "../../../../../packages/component/src/components/tag/demo/colored.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3233964802,
  legacyImportDemo_3320145185,
  legacyImportDemo_3997807168,
  legacyImportDemo_4074051308,
  React
};